module.exports = __webpack_public_path__ + "img/jlsLogo.5e6bd7eb.png";